// extracted by mini-css-extract-plugin
export default {"title":"styles_title__uvUmA","button-wrapper":"styles_button-wrapper__VmtOD","spin":"styles_spin__o1kdl","expand-button":"styles_expand-button__eaWLV"};